import { render, staticRenderFns } from "./Wrapper.vue?vue&type=template&id=7120ca66"
import script from "./Wrapper.vue?vue&type=script&lang=js"
export * from "./Wrapper.vue?vue&type=script&lang=js"
import style0 from "./Wrapper.vue?vue&type=style&index=0&id=7120ca66&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports